package empiresmp.feature.shop.ui

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Height
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.Width
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import empiresmp.components.FilledText
import empiresmp.components.Spacer
import empiresmp.components.alert.AlertDialog
import empiresmp.components.fade.AnimatedVisibility
import empiresmp.components.fade.Crossfade
import empiresmp.components.util.tryCast
import empiresmp.feature.shop.viewmodel.ShopViewModel
import kotlinx.browser.window
import ru.astrainteractive.kobwebx.core.resource.Hrefs
import ru.astrainteractive.kobwebx.core.theme.composable.LocalSitePalette
import ru.astrainteractive.kobwebx.core.theme.util.ThemeExt.typography

@Suppress("LongMethod")
@Composable
internal fun ConfirmDialog(
    username: String,
    itemState: ShopViewModel.SelectedItemState,
    onDismiss: () -> Unit,
    onConfirm: () -> Unit
) {
    val theme = LocalSitePalette.current

    AlertDialog(
        open = when (itemState) {
            is ShopViewModel.SelectedItemState.PreOrdered -> true
            is ShopViewModel.SelectedItemState.Selected -> true
            ShopViewModel.SelectedItemState.Unselected -> false
        },
        onDismiss = {
            onDismiss.invoke()
        },
        modifier = Modifier
            .width(Width.FitContent)
            .height(Height.FitContent),
        content = {
            Crossfade(itemState) { itemState ->
                Column(
                    modifier = Modifier
                        .onClick { it.preventDefault(); it.stopPropagation() }
                        .borderRadius(theme.dimens.S)
                        .backgroundColor(theme.colors.colorPrimaryVariant)
                        .padding(theme.dimens.S),
                    verticalArrangement = Arrangement.Center,
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    if (username.isEmpty()) {
                        SpanText(
                            text = "Вы не ввели свой никнейм!",
                            modifier = theme.typography.h3.toModifier()
                                .color(theme.colors.colorError)
                        )
                    } else {
                        SpanText(
                            text = username,
                            modifier = theme.typography.h3.toModifier()
                                .color(theme.colors.colorOnPrimary)
                                .background(theme.colors.colorSecondary)
                                .borderRadius(theme.dimens.S)
                                .padding(theme.dimens.S)
                                .cursor(Cursor.Default)
                                .onClick { it.preventDefault(); it.stopPropagation() }
                        )
                        SpanText(
                            text = "К этому нику будет привязана покупка",
                            modifier = theme.typography.body1.toModifier()
                                .cursor(Cursor.Default)
                                .color(theme.colors.colorHintOnPrimary)
                                .fontWeight(FontWeight.SemiBold)
                                .onClick { it.preventDefault(); it.stopPropagation() }
                        )
                    }
                    SpanText(
                        text = "Ваша покупка:",
                        modifier = theme.typography.h3.toModifier()
                            .cursor(Cursor.Default)
                            .color(theme.colors.colorOnPrimary)
                            .onClick { it.preventDefault(); it.stopPropagation() }
                    )

                    AnimatedVisibility(
                        targetState = when (itemState) {
                            is ShopViewModel.SelectedItemState.PreOrdered -> itemState.selectedItemData
                            is ShopViewModel.SelectedItemState.Selected -> itemState.selectedItemData
                            ShopViewModel.SelectedItemState.Unselected -> null
                        },
                        horizontalAnimation = false,
                        verticalAnimation = false
                    ) {
                        ShopItemCard(
                            itemData = it,
                            onClick = onConfirm,
                            isEnabled = username.isNotBlank() &&
                                itemState !is ShopViewModel.SelectedItemState.PreOrdered,
                            buttonText = "Подтвердить"
                        )
                    }

                    AnimatedVisibility(
                        itemState
                            .tryCast<ShopViewModel.SelectedItemState.PreOrdered>()
                            ?.uniquePhrase
                    ) { uniquePhrase ->
                        Column(
                            modifier = Modifier.fillMaxWidth(),
                            horizontalAlignment = Alignment.CenterHorizontally
                        ) {
                            SpanText(
                                text = "Чтобы продолжить покупку отправьте телеграм боту:",
                                modifier = theme.typography.body1.toModifier()
                                    .cursor(Cursor.Default)
                                    .color(theme.colors.colorHintOnPrimary)
                                    .fontWeight(FontWeight.SemiBold)
                                    .onClick { it.preventDefault(); it.stopPropagation() }
                                    .fillMaxWidth()
                                    .textAlign(TextAlign.Center)
                            )

                            SpanText(
                                text = "/order $uniquePhrase",
                                modifier = theme.typography.h3.toModifier()
                                    .fillMaxWidth()
                                    .color(theme.colors.colorOnPrimary)
                                    .background(theme.colors.colorPrimary)
                                    .borderRadius(theme.dimens.S)
                                    .padding(theme.dimens.S)
                                    .cursor(Cursor.Default)
                                    .onClick { it.preventDefault(); it.stopPropagation() }
                                    .textAlign(TextAlign.Center)
                            )
                            Box(
                                modifier = Modifier.fillMaxWidth()
                                    .margin(topBottom = theme.dimens.S),
                                contentAlignment = Alignment.Center
                            ) {
                                FilledText(
                                    modifier = Modifier.fillMaxWidth(),
                                    text = "Открыть бота",
                                    fillColor = theme.colors.colorSecondary,
                                    textColor = theme.colors.colorOnSecondary,
                                    onClick = {
                                        window.open(Hrefs.DISCORD_BOT_SHOP, "_blank")
                                    }
                                )
                            }
                        }
                    }

                    Spacer()
                    Box(
                        modifier = Modifier.fillMaxWidth().margin(top = theme.dimens.S),
                        contentAlignment = Alignment.Center
                    ) {
                        FilledText(
                            modifier = Modifier.fillMaxWidth(),
                            text = "Закрыть",
                            fillColor = theme.colors.colorError,
                            textColor = theme.colors.colorOnSecondary,
                            onClick = { onDismiss.invoke() }
                        )
                    }
                }
            }
        }
    )
}
